import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import MainComponentWrapper from "../../../Common/MainComponentWrapper";
import { updCartData } from "../../../../ReduxSlice/Checkout/cartSlice";
import AddonsList from "../../../../Pages/Organizer/EventMgt/AddonsList";
import useHttpHook from "../../../../Hooks/HttpHook";
import {
  GetAddonsApi,
  GetAllAddonsByOrderId,
} from "../../../../utils/ApiConstant";

const CheckoutSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  const [addons, setAddons] = useState([]);
  const [purchasedAddons, setPurchasedAddons] = useState([]);
  const [addonLoading, setAddonLoading] = useState(false);
  const [loading, sendRequest, error] = useHttpHook();
  const [searchParams] = useSearchParams();

  const eventId =
    searchParams.get("eventId") || searchParams.get("eventid") || "";
  const orderId =
    searchParams.get("orderId") || searchParams.get("orderid") || "";

  const getEventAddons = async (id) => {
    try {
      setAddonLoading(true);
      const response = await sendRequest(GetAddonsApi + id);
      if (response?.status === 1) {
        setAddons(Array.isArray(response.data) ? response.data : []);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setAddonLoading(false);
    }
  };

  const getPurchasedAddons = async (id) => {
    try {
      const response = await sendRequest(GetAllAddonsByOrderId + id, {
        method: "get",
      });
      if (response?.status === 1) {
        setPurchasedAddons(Array.isArray(response.data) ? response.data : []);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (eventId) {
      getEventAddons(eventId);
    }
    if (orderId) {
      getPurchasedAddons(orderId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId, orderId]);

  const displayName =
    userDetails?.userName ||
    userDetails?.firstName ||
    userDetails?.name ||
    "there";

  const purchasedIds = new Set(
    purchasedAddons.map((addon) => String(addon?._id || ""))
  );
  const exploreAddons = addons.filter(
    (addon) => !purchasedIds.has(String(addon?._id || ""))
  );

  const hotelTickets =
    cart?.data?.tickets?.filter((ticket) => ticket.hotellink) || [];

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <div className="event-thanks-body">
        <section className="event-thanks-card" aria-label="Order confirmation">
          <div className="event-thanks-icon" aria-hidden="true">
            <i className="bi bi-check-lg" />
          </div>

          <div className="event-thanks-copy">
            <h1 className="event-thanks-title">Thanks for your order!</h1>
            <p className="event-thanks-message">
              Hi <span>{displayName}</span>, your tickets will show up in Orders
              shortly.
            </p>
          </div>

          <button
            type="button"
            className="event-thanks-btn"
            onClick={() => {
              dispatch(updCartData({ data: {}, status: false }));
              navigate("/myOrders");
            }}
          >
            View or manage orders
          </button>

          {hotelTickets.length > 0 ? (
            <div className="event-thanks-hotel-links">
              <p>Need a hotel? Open a booking link below:</p>
              {hotelTickets.map((ticket, index) => (
                <a
                  key={`hotel-${index}`}
                  href={ticket.hotellink}
                  target="_blank"
                  rel="noreferrer"
                >
                  Hotel option {index + 1}
                </a>
              ))}
            </div>
          ) : null}
        </section>

        {purchasedAddons.length > 0 ? (
          <section
            className="event-thanks-addons"
            aria-label="Purchased add-ons"
          >
            <AddonsList
              addons={purchasedAddons}
              loading={false}
              redirection={true}
              layout="explore"
              showHeading={true}
              heading="Your add-ons"
              subheading="Extras included with this order."
            />
          </section>
        ) : null}

        {addonLoading || exploreAddons.length > 0 ? (
          <section
            className="event-thanks-addons"
            aria-label="Explore more add-ons"
          >
            <AddonsList
              addons={exploreAddons}
              loading={addonLoading}
              redirection={true}
              layout="explore"
              showHeading={true}
            />
          </section>
        ) : null}
      </div>
    </MainComponentWrapper>
  );
};

export default CheckoutSuccess;
